import {IDotRezPassengerSegmentFare} from "../../../dot-rez-api/data-contracts/booking/booking-state/booking-state.data-contracts";
import {Price} from "../../../currency/price";
import {
    isDiscountServiceCharge,
    sumOfNonTaxesServiceCharges,
    TAXES_SERVICE_CHARGES,
} from "../base-models/fees/service-charges.helpers";
import {computed, makeObservable} from "mobx";
import {IPassengerSegmentShoppingCartAdapter} from "../base-models/shopping-cart/passenger-segment-shopping-cart-adapter.interface";
import {TravelTaxModel} from "./travel-tax.model";

export class PassengerSegmentFareModel {
    constructor(private readonly passengerSegment: IPassengerSegmentShoppingCartAdapter) {
        makeObservable(this, {
            dotRezFares: computed
        });
    }

    get dotRezFares(): IDotRezPassengerSegmentFare[] {
        let fares: IDotRezPassengerSegmentFare[] = [];
        this.passengerSegment.segmentFares.forEach(segmentFare => {
            fares = [
                ...fares,
                ...segmentFare.passengerFares.filter(pFare => this.passengerSegment.passengerType.code === pFare.passengerType  && pFare.discountCode === this.passengerSegment.passengerDiscountCode)
            ];
        });

        return fares;
    }

    get flightPrice(): Price {
        return this.passengerSegment.createPrice(this.dotRezFares.sum(fare => sumOfNonTaxesServiceCharges(fare.serviceCharges)));
    }

    get taxes(): TravelTaxModel[] {
        return this.dotRezFares.selectMany(fare => fare.serviceCharges.filter(sc => TAXES_SERVICE_CHARGES.includes(sc.type)))
                               .map(sc => new TravelTaxModel(sc.code, 1, this.passengerSegment.createPrice(sc.amount), this.passengerSegment.services));

    }

    get taxesTotal(): Price {
        return Price.sumAll(this.taxes.map(t => t.total), this.passengerSegment.createPrice(0));
    }




    get hasPromotionApplied(): boolean {
        return this.dotRezFares.some(f => f.serviceCharges.some(sc => isDiscountServiceCharge(sc.type) && sc.amount > 0));
    }
}
